import { render, staticRenderFns } from "./PartnerCompaniesList.vue?vue&type=template&id=707855e0&scoped=true"
import script from "./PartnerCompaniesList.vue?vue&type=script&lang=js"
export * from "./PartnerCompaniesList.vue?vue&type=script&lang=js"
import style0 from "./PartnerCompaniesList.vue?vue&type=style&index=0&id=707855e0&prod&lang=scss&scoped=true"
import style1 from "./PartnerCompaniesList.vue?vue&type=style&index=1&id=707855e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707855e0",
  null
  
)

export default component.exports